import React from 'react';
import { HighlightKeyword } from 'bench-internal-theme';
import { InternalNote, JournalEntryComment } from '../types';
import FloatingExpandableText from '../../FloatingExpandableText';
import {
  NotesLayout,
  NotesListCell,
  NotesLabelCell,
  NotesGrid,
} from './DataEntryTableNotesColumn.styles';
import { removeLeadingAndTrailingQuotes } from './DataEntryTableColumnDefinitions';

export type NotesColumnProps = {
  internalNotes: InternalNote[];
  comments: JournalEntryComment[];
  clientSuggestion: string | undefined;
  search: string | undefined;
};

const DataEntryTableNotesColumn = ({
  internalNotes,
  comments,
  clientSuggestion,
  search,
}: NotesColumnProps) => {
  return (
    <NotesLayout>
      {(comments.length > 0 || internalNotes.length > 0 || !!clientSuggestion) && (
        <NotesGrid>
          {comments.length > 0 && (
            <>
              <NotesLabelCell title="Client Comments">CC:</NotesLabelCell>
              <NotesListCell>
                {comments.map(({ body, createdOn }) => (
                  <FloatingExpandableText key={`${body}-${createdOn}`}>
                    <HighlightKeyword keyword={removeLeadingAndTrailingQuotes(search)}>
                      {body}
                    </HighlightKeyword>
                  </FloatingExpandableText>
                ))}
              </NotesListCell>
            </>
          )}
          {!!clientSuggestion && (
            <>
              <NotesLabelCell title="Client Categorization Note">CN:</NotesLabelCell>
              <NotesListCell>
                <FloatingExpandableText>
                  <HighlightKeyword keyword={removeLeadingAndTrailingQuotes(search)}>
                    {clientSuggestion}
                  </HighlightKeyword>
                </FloatingExpandableText>
              </NotesListCell>
            </>
          )}
          {internalNotes.length > 0 && (
            <>
              <NotesLabelCell title="Internal Notes">IN:</NotesLabelCell>
              <NotesListCell>
                {internalNotes.map(({ body, createdOn }) => (
                  <FloatingExpandableText key={`${body}=${createdOn}`}>
                    <HighlightKeyword keyword={removeLeadingAndTrailingQuotes(search)}>
                      {body}
                    </HighlightKeyword>
                  </FloatingExpandableText>
                ))}
              </NotesListCell>
            </>
          )}
        </NotesGrid>
      )}
    </NotesLayout>
  );
};

export default DataEntryTableNotesColumn;
